// extracted by mini-css-extract-plugin
export default {"changeLink":"aS-z","disabled":"bS-z","inline":"cS-z"};